var _defs, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccuracy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1b140e32e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.777344 84.777344 L 290.277344 84.777344 L 290.277344 290.277344 L 84.777344 290.277344 Z M 84.777344 84.777344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "98e749eebb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134 134 L 241 134 L 241 290.277344 L 134 290.277344 Z M 134 134 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba607accc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 123 269 L 231 269 L 231 290.277344 L 123 290.277344 Z M 123 269 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1b140e32e4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2b5285",
    d: "M 290.277344 187.527344 C 290.277344 244.273438 244.273438 290.277344 187.527344 290.277344 C 130.777344 290.277344 84.777344 244.273438 84.777344 187.527344 C 84.777344 130.777344 130.777344 84.777344 187.527344 84.777344 C 244.273438 84.777344 290.277344 130.777344 290.277344 187.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 272.558594 187.527344 C 272.558594 234.488281 234.488281 272.558594 187.527344 272.558594 C 140.5625 272.558594 102.492188 234.488281 102.492188 187.527344 C 102.492188 140.5625 140.5625 102.492188 187.527344 102.492188 C 234.488281 102.492188 272.558594 140.5625 272.558594 187.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b5285",
    d: "M 254.84375 187.527344 C 254.84375 224.703125 224.703125 254.84375 187.527344 254.84375 C 150.347656 254.84375 120.207031 224.703125 120.207031 187.527344 C 120.207031 150.347656 150.347656 120.207031 187.527344 120.207031 C 224.703125 120.207031 254.84375 150.347656 254.84375 187.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#98e749eebb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefaf4",
    d: "M 233.585938 134.378906 L 141.464844 134.378906 C 137.550781 134.378906 134.378906 137.550781 134.378906 141.464844 L 134.378906 269.015625 L 219.414062 269.015625 C 221.371094 269.015625 222.957031 270.601562 222.957031 272.558594 L 222.957031 283.1875 C 222.957031 287.074219 226.085938 290.226562 229.960938 290.273438 C 230.054688 290.273438 230.152344 290.277344 230.25 290.273438 C 236.023438 290.164062 240.671875 285.449219 240.671875 279.644531 L 240.671875 141.464844 C 240.671875 137.550781 237.5 134.378906 233.585938 134.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 222.957031 222.957031 L 222.957031 166.265625 L 208.785156 166.265625 L 208.785156 222.957031 L 194.613281 222.957031 L 194.613281 187.527344 L 180.4375 187.527344 L 180.4375 222.957031 L 166.265625 222.957031 L 166.265625 194.613281 L 152.09375 194.613281 L 152.09375 222.957031 L 145.007812 222.957031 L 145.007812 230.042969 L 230.042969 230.042969 L 230.042969 222.957031 L 222.957031 222.957031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f29323",
    d: "M 182.945312 175.859375 L 177.933594 170.847656 L 234.625 114.160156 L 239.632812 119.167969 L 182.945312 175.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf6a27",
    d: "M 247.757812 88.320312 L 235.660156 100.414062 C 234.332031 101.742188 233.585938 103.546875 233.585938 105.425781 L 233.585938 120.207031 L 248.367188 120.207031 C 250.246094 120.207031 252.050781 119.460938 253.378906 118.128906 L 265.472656 106.035156 L 251.300781 102.492188 L 247.757812 88.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 166.265625 244.214844 L 145.007812 244.214844 L 145.007812 237.128906 L 166.265625 237.128906 L 166.265625 244.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 183.984375 244.214844 L 173.351562 244.214844 L 173.351562 237.128906 L 183.984375 237.128906 L 183.984375 244.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 166.265625 258.386719 L 145.007812 258.386719 L 145.007812 251.300781 L 166.265625 251.300781 L 166.265625 258.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 183.984375 258.386719 L 173.351562 258.386719 L 173.351562 251.300781 L 183.984375 251.300781 L 183.984375 258.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 212.328125 244.214844 L 191.070312 244.214844 L 191.070312 237.128906 L 212.328125 237.128906 L 212.328125 244.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 230.042969 244.214844 L 219.414062 244.214844 L 219.414062 237.128906 L 230.042969 237.128906 L 230.042969 244.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 212.328125 258.386719 L 191.070312 258.386719 L 191.070312 251.300781 L 212.328125 251.300781 L 212.328125 258.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#63c784",
    d: "M 230.042969 258.386719 L 219.414062 258.386719 L 219.414062 251.300781 L 230.042969 251.300781 L 230.042969 258.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f29323",
    d: "M 198.15625 176.894531 L 176.894531 176.894531 L 176.894531 155.636719 L 183.984375 155.636719 L 183.984375 169.808594 L 198.15625 169.808594 L 198.15625 176.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba607accc0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c1bfbd",
    d: "M 230.042969 290.277344 L 134.378906 290.277344 C 128.507812 290.277344 123.75 285.515625 123.75 279.644531 L 123.75 272.558594 C 123.75 270.601562 125.335938 269.015625 127.292969 269.015625 L 219.414062 269.015625 C 221.371094 269.015625 222.957031 270.601562 222.957031 272.558594 L 222.957031 283.1875 C 222.957031 287.101562 226.128906 290.277344 230.042969 290.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracy);
export default __webpack_public_path__ + "static/media/accuracy.626a6a36ffd8322e9846c380b835c32b.svg";
export { ForwardRef as ReactComponent };